import {
    Flex,
    useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

export default function SidebarDocs() {
    const bgColor = "linear-gradient(135deg, #868CFF 0%, #4318FF 100%)";
    const borderColor = useColorModeValue("white", "navy.800");

    return (
        <Flex
            justify='center'
            direction='column'
            align='center'
            bg={bgColor}
            borderRadius='30px'
            position='relative'>
        </Flex>
    );
}
